import {
    EntityType as ENTITY_TYPE,
    InviteStatus as INVITE_STATUS,
    Permission as PERMISSION,
} from '@/graphql/types';
import { schema } from '../../../schema';

export const ENTITY_TYPE_TRANSLATIONS = Object.freeze({
    [ENTITY_TYPE.User]: gettext('ACCOUNT'),
    [ENTITY_TYPE.MeasuringPoint]: gettext('MEASURING_POINT'),
    [ENTITY_TYPE.Project]: gettext('PROJECT'),
});

// Re-export for backward compatibility
export { PERMISSION, INVITE_STATUS, ENTITY_TYPE };

// The backend owns the hierarchy (GraphQL enums carry no ordering). Typing it against the
// GraphQL enum makes a permission that exists on one side but not the other a compile error.
const PERMISSION_LEVELS: Readonly<Record<PERMISSION, number>> = schema.permissionLevels;

export function hasAtLeastPermission(actual: PERMISSION, required: PERMISSION): boolean {
    return PERMISSION_LEVELS[actual] >= PERMISSION_LEVELS[required];
}

// Reference access follows from sharing a measuring point and is never granted directly.
export const SHAREABLE_PERMISSIONS: readonly PERMISSION[] = Object.freeze(
    Object.values(PERMISSION).filter((permission) =>
        hasAtLeastPermission(permission, PERMISSION.View)
    )
);

// GraphQL declares `permission` nullable, but the backend always resolves one for an entity
// the user can see.
// TODO: Remove once `permission` is non-nullable in the schema, which is in scope of #8944
// (https://github.com/omnidots/website/pull/9312).
export function requirePermission(
    permission: PERMISSION | null | undefined,
    entityLabel: string
): PERMISSION {
    if (!permission) {
        throw new Error(`Missing permission for ${entityLabel}.`);
    }

    return permission;
}

export const PERMISSION_TRANSLATIONS = Object.freeze({
    [PERMISSION.Reference]: gettext('PERMISSION_REFERENCE'),
    [PERMISSION.View]: gettext('PERMISSION_VIEW'),
    [PERMISSION.FullAccess]: gettext('PERMISSION_FULL_ACCESS'),
});
